import React from "react";
import Layout from "./layout";

function PrivacyPolicy() {
  return (
    <Layout>
      <div className="bg-gray-100 min-h-screen">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <h2 className="text-2xl font-semibold mb-4">Privacy Policy</h2>
          <p className="mb-4">
            At Substantile, we take your privacy seriously and are committed to
            providing a secure online experience. This Privacy Policy outlines
            our data collection and usage practices. By using our site, you
            agree to the terms outlined here. This policy does not override any
            direct agreements between you and Substantile.
          </p>
          <p className="font-semibold mb-2">Optional Participation</p>
          <p className="mb-4">
            Participation in online forms is voluntary. We may request details
            such as your name, address, email, employer, and job title. For
            purchases, a credit card number may be required. Some information
            may be mandatory for specific activities.
          </p>
          <p className="font-semibold mb-2">Data Collection and Storage</p>
          <p className="mb-4">
            We collect personal information only when necessary, typically for
            subscription services, premium content access, or purchases. This
            information may include your name, email, phone number, and
            location. Additional details may be required for specific requests
            or orders.
          </p>
          <p className="font-semibold mb-2">Optional Participation</p>
          <p className="mb-4">
            Upon the purchase and installation of new products, we may request
            electronic registration. This registration information is stored
            alongside any previously provided details from your previous visits
            to our website, forming your personal profile.
          </p>
          <p className="font-semibold mb-2">Technical Information </p>
          <p className="mb-4">
            We collect technical information like IP addresses, browser types,
            and traffic patterns. We may use cookies for system administration.
            You can configure your browser to manage cookies.
          </p>
          <p className="mb-4">
            It's important to note that while Substantile may track a visitor's
            arrival at the website, we do not and will not gather information
            about the other sites you have visited. Additionally, we do not link
            IP addresses to personally identifiable details.
          </p>
          <p className="font-semibold mb-2">Data Use</p>
          <p className="mb-4">
            Your personal information helps streamline your site experience,
            create relevant content, and notify you of updates, offers, and new
            products. To unsubscribe from communications, use
          </p>
          <p className="font-semibold mb-2">External Links </p>
          <p className="mb-4">
            Our site may link to external websites. Please review their privacy
            policies, as they are not governed by ours. We are not responsible
            for third-party privacy practices.
          </p>
          <p className="font-semibold mb-2">Legal Compliance </p>
          <p className="mb-4">
            We may disclose your information to comply with legal requirements,
            protect our rights, or prevent harm. This includes cooperating with
            government or law enforcement officials.
          </p>
          <p className="font-semibold mb-2">Security </p>
          <p className="mb-4">
            We use advanced security measures to protect your information. Your
            data is securely stored behind firewall protection. Access is
            limited to authorized personnel
          </p>
          <p className="font-semibold mb-2">EU-US Privacy Shield</p>
          <p className="mb-4">
            We comply with the EU-US Privacy Shield framework for data transfers
            from the EEA. This ensures adherence to stringent privacy standards.
            By using our site, you consent to data
          </p>
          <p className="font-semibold mb-2">Third-Party Transfers </p>
          <p className="mb-4">
            We follow procedures for transferring personal data to third
            parties, ensuring they uphold Privacy Shield protections. We are
            accountable for third-party actions under the Privacy Shield
            framework.
          </p>
          <p className="font-semibold mb-2">Complaints Resolution</p>
          <p className="mb-4">
            We address privacy complaints promptly. If unresolved, you can
            escalate to your local data protection authority or seek binding
            arbitration. The Federal Trade Commission oversees our compliance
            with Privacy Shield.
          </p>

          <p className="font-semibold mb-2">Access Rights</p>
          <p className="mb-4">
            You can request access, correction, or deletion of your personal
            data. This is subject to legal obligations and practical
            limitations. Contact us for these requests, and we may require
            identity verification.
          </p>

          <p className="font-semibold mb-2">GDPR Compliance</p>
          <p className="mb-4">
            As data processors, we handle personal information solely to support
            our services. We ensure strict adherence to data protection
            principles, never using your information for our own purposes.
          </p>
        </div>
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
